import React, {useRef, useState} from 'react';
import {ClickAwayListener} from '@material-ui/core';
import PopupStyle from '../../../../styles/components/time_reg_popup_styled';
import {ProgressRegistration} from '../task-modal/sections/main-section/progress-tile/ProgressRegistration';
import {dispatch, EVENT_ID} from '../../../../containers/event_manager';
import ReactDOM from 'react-dom';
import {getPopupPosition} from '../../util/PopupUtil';
import {ProgressRegistrationIcon} from '@/web-components/design-icons';
import {CSS_CONSTANTS} from '../../../../css_variables';

export const ProgressRegistrationPopup = ({task}) => {
	const progressIconRef = useRef(null);
	const popupRef = useRef(null);

	const [isPopupVisible, setIsPopupVisible] = useState(false);
	const [popupPosition, setPopupPosition] = useState({});
	const [arrowPosition, setArrowPosition] = useState({});

	const handleIconClick = () => {
		if (progressIconRef.current) {
			const iconPosition = progressIconRef.current.getBoundingClientRect();

			requestAnimationFrame(() => {
				if (popupRef.current) {
					const popupPosition = popupRef.current.getBoundingClientRect();

					const result = getPopupPosition(iconPosition, popupPosition);

					setPopupPosition(result.popupPositionValues);
					setArrowPosition(result.arrowPositionValues);
				}
			});
		}
		dispatch(EVENT_ID.TIME_POPUP_OPENED, task.id);
		setIsPopupVisible(!isPopupVisible);
	};

	const closePopup = () => {
		if (isPopupVisible) {
			setIsPopupVisible(false);
		}
	};

	const onPopupClick = e => {
		e.target.focus();
	};

	return (
		<React.Fragment>
			<div className={'time-registration-icon'} ref={progressIconRef} onClick={handleIconClick}>
				<ProgressRegistrationIcon hoverColor={CSS_CONSTANTS.v2_branding_purple} />
			</div>

			{isPopupVisible
				? ReactDOM.createPortal(
						<ClickAwayListener onClickAway={closePopup}>
							<PopupStyle
								onClick={onPopupClick}
								popupPosition={popupPosition}
								arrowPosition={arrowPosition}
								ref={popupRef}
							>
								<ProgressRegistration task={task} close={closePopup} />
							</PopupStyle>
						</ClickAwayListener>,
						document.querySelector('#root-portal-container')
				  )
				: null}
		</React.Fragment>
	);
};
